import { render, staticRenderFns } from "./ImportStatus.vue?vue&type=template&id=2a609e2c"
import script from "./ImportStatus.vue?vue&type=script&lang=js"
export * from "./ImportStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports